import React, {createContext, useState} from 'react'

const ShippingOrderEditContext = createContext()
ShippingOrderEditContext.displayName = 'ShippingOrderEditContext'

const ShippingOrderProvider = ({children}) => {

    const [shipping, setShipping] = useState([])

    const values = {
        shippingObj: [shipping, setShipping]
    }

    return(
        <ShippingOrderEditContext.Provider value={values}>
            {children}
        </ShippingOrderEditContext.Provider>
    )

}
export {ShippingOrderEditContext, ShippingOrderProvider}